/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import CtaLink from '../../../ui/CtaLink';
import { types, sizes } from '../../../ui/CtaLink/types';
import * as styles from './index.styles';

const SitemapBlock = props => {
  const links = get(props, 'links', []);

  // Returns linkItems except the first one because the first one is the headline link.
  const linkItems = links.map(
    (link, index) =>
      index !== 0 && (
        <li css={styles.item} key={index}>
          <CtaLink
            linkCustomCss={styles.link}
            type={types.secondary}
            href={get(link, 'href', '#')}
            text={get(link, 'text', '')}
          />
        </li>
      ),
  );

  const headlineLinkFields = links[0] || false;

  return (
    <section>
      <h2 css={styles.headline}>
        {headlineLinkFields.href ? (
          <CtaLink
            linkCustomCss={styles.link}
            type={types.tertiary}
            size={sizes.large}
            href={headlineLinkFields.href || '#'}
            text={headlineLinkFields.text || ''}
          />
        ) : (
          <Text field={{ value: headlineLinkFields.text }} />
        )}
      </h2>
      <ul css={styles.items}>{linkItems}</ul>
    </section>
  );
};

SitemapBlock.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
};

export default SitemapBlock;
